import { FC } from 'react';
import { AgentService } from 'components/AgentService';
import { memberInfoSelector } from '@doda/common/src/redux/features/memberInfo';
import { useAppSelector } from '@doda/pc/src/redux/hooks';
import { useAgentService } from 'components/AgentService/hooks/useAgentService';
import { totalJobCountSelector } from '@doda/pc/src/redux/features/jobList';
import { AGENT_SERVICE_BASE_URL } from 'components/AgentService/constants';
import { PLPLINKLIST_JOBSEARCHLIST_UNDER } from '@doda/common/src/constants/seo';
import { SeoFooterLink } from 'components/SeoFooterLink';
import { useIsShowSeoFooterLink } from '@doda/common/src/hooks/jobSearchList/useIsShowSeoFooterLink';
import { RecommendList } from '../RecommendList';
import { PageProps } from '../../index.page';
import { Pagination } from '../Pagination';
import { PlpLinkList } from '../PlpLinkList';
import styles from '../../screens/index.module.scss';
import { JobRanking } from '../JobRanking';
import { JobContentLinkList } from '../JobContentLinkList';

/**
 * BodyFooterのProps
 * @param isShowPagination ページネーション表示判定フラグ
 * @param seoFooterLink SEOフッターリンク
 * @param similarKeywordList 類似キーワードリスト
 * @param b4rTsuukaABTestPattern AB test result for B4R recommend
 * @param jobContentLinkLists 求人コンテンツリンク集
 */
interface Props {
  isShowPagination: PageProps['isShowPagination'];
  seoFooterLink: PageProps['seoFooterLink'];
  similarKeywordList: PageProps['similarKeywordList'];
  b4rTsuukaABTestPattern: PageProps['b4rTsuukaABTestPattern'];
  jobRankings: PageProps['jobRankings'];
  jobContentLinkLists: PageProps['jobContentLinkLists'];
}

export const BodyFooter: FC<Props> = ({
  isShowPagination,
  seoFooterLink,
  similarKeywordList,
  b4rTsuukaABTestPattern,
  jobRankings,
  jobContentLinkLists,
}) => {
  const totalJobCount = useAppSelector(totalJobCountSelector);
  const memberInfo = useAppSelector(memberInfoSelector);
  const loginStatus = memberInfo?.loginStatus ?? false;
  const { shouldShowAgentService } = useAgentService(memberInfo?.wtsrfl);
  const agentServiceUrl = totalJobCount
    ? `${AGENT_SERVICE_BASE_URL}&usrclk_searchList=PC-${loginStatus ? 'login' : 'logout'}JobSearchList_searchResultFooterAddedArea_agentServiceRegist`
    : AGENT_SERVICE_BASE_URL;

  const isShowSeoFooterLink = useIsShowSeoFooterLink(totalJobCount);

  return (
    <div>
      <PlpLinkList position={PLPLINKLIST_JOBSEARCHLIST_UNDER} />
      {isShowPagination && (
        <div className={styles.jobSearchList__pagination}>
          <Pagination />
        </div>
      )}
      <RecommendList
        similarKeywordList={similarKeywordList}
        b4rTsuukaABTestPattern={b4rTsuukaABTestPattern}
      />

      {jobRankings.length > 0 && (
        <div className={styles.jobSearchList__jobRanking}>
          <JobRanking jobRankings={jobRankings} />
        </div>
      )}

      <div className={styles.jobSearchList__jobContentLinkList}>
        <JobContentLinkList jobContentLinkLists={jobContentLinkLists} />
      </div>

      {shouldShowAgentService && (
        <div className={styles.jobSearchList__agentService}>
          <AgentService href={agentServiceUrl} />
        </div>
      )}
      <div className={styles['jobSearchList__seo-footer']}>
        {isShowSeoFooterLink && (
          <>
            {seoFooterLink.map(({ boxName, boxLinks }) => (
              <SeoFooterLink
                title={boxName}
                listItems={boxLinks}
                key={boxName}
              />
            ))}
          </>
        )}
      </div>
    </div>
  );
};
